import type { FC, MouseEventHandler, ReactElement, JSX } from 'react';
import { createElement, forwardRef, memo } from 'react';
import Picture from '../Picture';
import './index.scss';
import type { IconType } from '@root/src/types';
import { twcls } from '@utils/twcls';

interface HoveredButtonProps {
  text?: string | ReactElement<any>;
  icon: IconType;
  iconHover: IconType;
  iconHeight?: number;
  iconWidth?: number;
  isReverse?: boolean;
  isActive?: boolean;
  alt?: string;
  wrapperClassName?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  component?: keyof JSX.IntrinsicElements;
}

const HoveredButton: FC<HoveredButtonProps> = forwardRef(
  (
    {
      text,
      icon,
      iconHover = '',
      iconHeight = 20,
      iconWidth = 20,
      isReverse,
      isActive,
      alt = 'Изображение',
      wrapperClassName = '',
      onClick,
      component
    },
    ref
  ) => {
    const Tag = component ? `${component}` : 'div';
    return createElement(
      Tag,
      {
        ref,
        onClick,
        className: twcls(
          `hovered-btn`,
          isActive && ' hovered-btn--active',
          isReverse && ' hovered-btn--reverse',
          iconHover === '' && ' hovered-btn--no-hover-icon',
          wrapperClassName || ''
        )
      },
      <>
        <Picture
          pictureClassName='hovered-btn__icon'
          icon={isActive ? iconHover || icon : icon}
          width={`${iconWidth}`}
          height={`${iconHeight}`}
          alt={alt}
        />
        <Picture
          pictureClassName='hovered-btn__icon-hover'
          icon={iconHover || icon}
          width={`${iconWidth}`}
          height={`${iconHeight}`}
          alt={alt}
        />
        {text && <span className='inline-flex'>{text}</span>}
      </>
    );
  }
);

export default memo(HoveredButton);
